import { defineStore } from 'pinia';

/**
 * Canvas edit mode: the plain design, or one node-graph overlay on top of it.
 * The overlays are exclusive, so at most one graph shows at a time. UI objects
 * stay editable in every mode.
 *
 * `available: false` keeps a mode out of reach until its editor exists.
 */
export const CANVAS_MODES = Object.freeze([
    { id: 'design', label: 'Design', title: 'Design the UI objects (Shift+Tab cycles modes)', available: true },
    { id: 'logic', label: 'Logic', title: 'Event and action nodes (Shift+Tab cycles modes)', available: true },
    { id: 'hass', label: 'HA', title: 'Home Assistant flows (Shift+H, Shift+Tab cycles modes)', available: true },
]);

export const useCanvasModeStore = defineStore('canvasMode', {
    state: () => ({
        mode: 'design',
    }),

    getters: {
        modes: () => CANVAS_MODES,
    },

    actions: {
        /** Switch to `mode`; unknown and unavailable modes are ignored. */
        setMode(mode) {
            if (CANVAS_MODES.some(item => item.id === mode && item.available)) this.mode = mode;
        },

        /** Switch to `mode`, or back to design when it is already active. */
        toggleMode(mode) {
            this.setMode(this.mode === mode ? 'design' : mode);
        },

        /** Step to the next available mode, wrapping back to the first. */
        cycleMode() {
            const available = CANVAS_MODES.filter(item => item.available);
            const index = available.findIndex(item => item.id === this.mode);
            this.mode = available[(index + 1) % available.length].id;
        },
    },
});
